import React, { useEffect, useState, useRef } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
} from "@mui/material";

const ConfirmDialogBox = ({ confirmDialog, setConfirmDiaog = () => { }, handleConfirm = () => { } }) => {

  const handleOnClose = () => {
    setConfirmDiaog({
        open: false,
        text: undefined,
        type: undefined
    })
  }
  return (
    <Dialog open={confirmDialog.open} onClose={handleOnClose}>
      <DialogContent>
        <Box>
          <Typography variant="h6">{confirmDialog.text}</Typography>
        </Box>
        <Box 
          sx={{ 
            marginTop: "2rem",
            display: "flex", 
            justifyContent: "flex-end",
            gap: 2 
          }}
        >
          <Button 
            variant="outlined" 
            onClick={handleOnClose}
            sx={{
              minWidth: '100px',
            }}
          >
            Cancel
          </Button>
          <Button 
            variant="contained" 
            onClick={handleConfirm}
            sx={{
              minWidth: '100px',
              backgroundColor: 'primary.main',
            }}
          >
            {confirmDialog.buttonText}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );};

export default ConfirmDialogBox;
